import { css } from '@/styled-system/css';

export const stack = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
});

export const header = css({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 'tighter',
});

export const footerRow = css({
  display: 'flex',
  justifyContent: 'center',
});
